<template>
  <div class="split-table-wrapper">
    <slot></slot>
    <RkTable
      class="split-table"
      :data="sliceEventList"
      :loading="loading"
      :finished="finished"
      :show-footer="showFooter"
    >
      <template #footer>
        <ShowMoreButton v-if="eventList.length > initLength" v-model="isMore" />
      </template>
      <RkTableColumn prop="reportDate" label="报告日期" :width="`${postcssPatch(100)}`" align="left">
        <template #default="{ row }">{{ $digitjs(row.reportDate).isNull() }}</template>
      </RkTableColumn>
      <RkTableColumn prop="splitType" label="方式">
        <template #default="{ row }">{{ $digitjs(row.splitType).isNull() }}</template>
      </RkTableColumn>
      <RkTableColumn prop="splitRatio" label="比例" :width="`${postcssPatch(100)}`">
        <template #default="{ row }">{{ $digitjs(row.splitRatio).isNull() }}</template>
      </RkTableColumn>
      <RkTableColumn prop="exDate" label="除净日" :width="`${postcssPatch(100)}`">
        <template #default="{ row }">{{ $digitjs(row.exDate).isNull() }}</template>
      </RkTableColumn>
    </RkTable>
  </div>
</template>

<script>
import ShowMoreButton from '@/components/common/ShowMoreButton.vue'
import { postcssPatch } from '@/utils/postcssPatch'
export default {
  components: { ShowMoreButton },
  props: {
    showFooter: {
      type: Boolean,
      default: false
    },
    total: {
      type: Number
    },
    initLength: {
      type: Number,
      default: 10
    }
  },
  data() {
    return {
      loading: false,
      finished: false,
      isMore: false,
      eventList: []
    }
  },
  computed: {
    symbol() {
      return this.$route.query.symbol
    },
    market() {
      return this.$funs.getMarket(this.symbol)
    },
    sliceEventList() {
      if (this.total) {
        return this.eventList
      } else {
        return this.isMore ? this.eventList : this.eventList.slice(0, this.initLength)
      }
    }
  },
  created() {
    this.getEventList()
  },
  methods: {
    postcssPatch,
    async getEventList() {
      this.loading = true
      const res = await this.$post(this.$api.f10[this.market] + '/summary/ca-splits', {
        startDate: '1990-01-01',
        symbol: this.symbol
      })
      this.eventList = res.data?.slice(0, this.total) ?? []
      this.finished = true
      this.loading = false
    }
  }
}
</script>

<style lang="scss" scoped>
.split-table-wrapper {
  margin-bottom: var(--section-margin);
  background: var(--bg-color-2);
}

.split-table {
  --table-tbody-font-size: 13px;
}
</style>
